import { useMutation, useQueryClient } from '@tanstack/react-query';

interface CreateConditionParams {
  custom_tag_id: number;
  condition_column: string;
  condition_content: string;
  condition_type: string;
}

/**
 * タグ条件を作成するフック
 */
export default function useCreateTagCondition() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (params: CreateConditionParams) => {
      const { custom_tag_id, ...conditionData } = params;
      const response = await fetch(`/agent/api/custom_tags/${custom_tag_id}/conditions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          custom_tag_condition: conditionData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || '条件の保存に失敗しました');
      }

      return response.json();
    },
    onSuccess: (_, variables) => {
      // 条件一覧を再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/custom_tags', variables.custom_tag_id, 'conditions'],
      });
    },
  });
}
